import React from 'react'
import { Link } from 'react-router-dom'

const EventsRequested = () => {
  return (
    
    <div className='modal-tabs-follow-sec'>
        <div className='alert-box-com'>
            <div className='alert-box'>
                <div class="alert alert-dismissible d-flex align-items-center fade show mb-3" role="alert">
                    <div className='left-alert-box d-flex align-items-center'>
                        <div className='left-img-box'>
                            <div className='img-box'></div>
                        </div>
                        <div className='right-text-box'>
                            <h6>iamchloe</h6>
                            <p>Chloe</p>
                        </div>
                    </div>
                    <div className='right-alert-box d-flex align-items-center'>
                        <div className='btn-box-alert'>
                            <Link rel='stylesheet' to="/" className='btn btn-border'>Accept</Link>
                        </div>
                        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                    </div>
                </div>
            </div>
            <div className='alert-box'>
                <div class="alert alert-dismissible d-flex align-items-center fade show mb-3" role="alert">
                    <div className='left-alert-box d-flex align-items-center'>
                        <div className='left-img-box'>
                            <div className='img-box'></div>
                        </div>
                        <div className='right-text-box'>
                            <h6>iamchloe</h6>
                            <p>Chloe</p>
                        </div>
                    </div>
                    <div className='right-alert-box d-flex align-items-center'>
                        <div className='btn-box-alert'>
                            <Link rel='stylesheet' to="/" className='btn btn-border'>Accept</Link>
                        </div>
                        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                    </div>
                </div>
            </div>
            <div className='alert-box'>
                <div class="alert alert-dismissible d-flex align-items-center fade show mb-3" role="alert">
                    <div className='left-alert-box d-flex align-items-center'>
                        <div className='left-img-box'>
                            <div className='img-box'></div>
                        </div>
                        <div className='right-text-box'>
                            <h6>iamchloe</h6>
                            <p>Chloe</p>
                        </div>
                    </div>
                    <div className='right-alert-box d-flex align-items-center'>
                        <div className='btn-box-alert'>
                            <Link rel='stylesheet' to="/" className='btn btn-border'>Accept</Link>
                        </div>
                        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                    </div>
                </div>
            </div>
            <div className='alert-box'>
                <div class="alert alert-dismissible d-flex align-items-center fade show mb-3" role="alert">
                    <div className='left-alert-box d-flex align-items-center'>
                        <div className='left-img-box'>
                            <div className='img-box'></div>
                        </div>
                        <div className='right-text-box'>
                            <h6>iamchloe</h6>
                            <p>Chloe</p>
                        </div>
                    </div>
                    <div className='right-alert-box d-flex align-items-center'>
                        <div className='btn-box-alert'>
                            <Link rel='stylesheet' to="/" className='btn btn-border'>Accept</Link>
                        </div>
                        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                    </div>
                </div>
            </div>
            <div className='alert-box'>
                <div class="alert alert-dismissible d-flex align-items-center fade show mb-3" role="alert">
                    <div className='left-alert-box d-flex align-items-center'>
                        <div className='left-img-box'>
                            <div className='img-box'></div>
                        </div>
                        <div className='right-text-box'>
                            <h6>iamchloe</h6>
                            <p>Chloe</p>
                        </div>
                    </div>
                    <div className='right-alert-box d-flex align-items-center'>
                        <div className='btn-box-alert'>
                            <Link rel='stylesheet' to="/" className='btn btn-border'>Accept</Link>
                        </div>
                        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                    </div>
                </div>
            </div>
            <div className='alert-box'>
                <div class="alert alert-dismissible d-flex align-items-center fade show mb-3" role="alert">
                    <div className='left-alert-box d-flex align-items-center'>
                        <div className='left-img-box'>
                            <div className='img-box'></div>
                        </div>
                        <div className='right-text-box'>
                            <h6>iamchloe</h6>
                            <p>Chloe</p>
                        </div>
                    </div>
                    <div className='right-alert-box d-flex align-items-center'>
                        <div className='btn-box-alert'>
                            <Link rel='stylesheet' to="/" className='btn btn-border'>Accept</Link>
                        </div>
                        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                    </div>
                </div>
            </div>
            <div className='alert-box'>
                <div class="alert alert-dismissible d-flex align-items-center fade show mb-3" role="alert">
                    <div className='left-alert-box d-flex align-items-center'>
                        <div className='left-img-box'>
                            <div className='img-box'></div>
                        </div>
                        <div className='right-text-box'>
                            <h6>iamchloe</h6>
                            <p>Chloe</p>
                        </div>
                    </div>
                    <div className='right-alert-box d-flex align-items-center'>
                        <div className='btn-box-alert'>
                            <Link rel='stylesheet' to="/" className='btn btn-border'>Accept</Link>
                        </div>
                        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default EventsRequested
